import { map, atom } from "nanostores";

type GlideSettings = {
  type: string;
  peek: number;
  gap: number;
  perView: number;
  breakpoints: Record<string, string>;
};

export const $glideSettings = map({
  type: "",
  peek: 0,
  gap: 0,
  perView: 0,
  breakpoints: {},
});

export const $totalSlides = atom(0);
export const $currentIndex = atom(0);

export const setGlideSettings = (settings: GlideSettings) => {
  $glideSettings.set(settings);
};

export const setTotalSlides = (total: number) => {
  $totalSlides.set(total);
};

export const setCurrentIndex = (index: number) => {
  $currentIndex.set(index);
};
